export default class Legal {

    constructor() {
        this.addEvents();
    }

    addEvents() {
        const tabs = document.querySelectorAll('.legal-tab__head--item');
        const contentItems = document.querySelectorAll('.legal-tab__content--item');
        if(tabs.length > 0) {
            tabs.forEach(function (tab, index) {
                tab.addEventListener('click', function (e) {
                    e.preventDefault();

                    tabs.forEach(function (tab) {
                        tab.classList.remove('active');
                    });

                    contentItems.forEach(function (contentItem) {
                        contentItem.classList.remove('active');
                    });

                    tab.classList.add('active');
                    contentItems[index].classList.add('active');
                });
            });
        }
    }

}


